export default "__VITE_ASSET__CSeStRYH__"